import { render, staticRenderFns } from "./NumberPoolForm.vue?vue&type=template&id=20c8d14c"
import script from "./NumberPoolForm.vue?vue&type=script&lang=js"
export * from "./NumberPoolForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports